import { useMemo } from 'react';
import Corn from 'assets/icons/corn.svg';
import Barley from 'assets/icons/barley_crop.svg';
import Wheat from 'assets/icons/wheat_crop.svg';
import Sunflower from 'assets/icons/sunflower_crop.svg';
import Soyabean from 'assets/icons/soyabean_crop.svg';
import { Skeleton } from 'syngenta-digital-cropwise-react-ui-kit';
import { CropConstants } from 'utils/constants/Crop';
import { TFunction } from 'i18next';
import {
  RecommendationCropwise,
  RecommendationCropwiseResponse,
} from 'base/types/RecommendationCropwise';
import { isBrazil } from 'utils/countryCode';

export const getCropIcon = (cropName: string | undefined) => {
  switch (cropName) {
    case 'corn':
    case 'silage corn':
    case 'summer corn':
      return Corn;
    case 'sunflower':
      return Sunflower;
    case 'barley':
      return Barley;
    case 'wheat':
      return Wheat;
    case 'soybeans':
      return Soyabean;
    default:
      return Corn;
  }
};

const capitalizeCropType = (cropType: string | undefined): string => {
  if (!cropType) {
    return '';
  }
  return cropType
    .split(' ')
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const HYVIDO_CROP_TYPES = new Set([CropConstants.BARLEY, CropConstants.HYBRID_BARLEY]);

const BRAZIL_CROP_NAMES: Record<number, string> = {
  [CropConstants.CORN_CROP_ID]: 'Safrinha corn',
  [CropConstants.SUMMER_CORN_CROP_ID]: 'Safra corn',
  [CropConstants.SOYBEANS_CROP_ID]: 'Soybeans',
};

export const getCropName = (
  recommendationCW: RecommendationCropwise | any,
  recommendationCropwise: RecommendationCropwiseResponse | any,
  t: TFunction
): string => {
  const { crop_type: cropType, crop_id: cropId } = recommendationCW || {};
  if (HYVIDO_CROP_TYPES.has(cropType)) {
    return t('Hyvido');
  }
  return (
    (isBrazil(recommendationCropwise?.country) && BRAZIL_CROP_NAMES[cropId]) ||
    t(capitalizeCropType(cropType))
  );
};

export const useSkeletonLoader = () => {
  return useMemo(() => {
    return (
      <Skeleton
        active
        style={{ padding: '100px 64px 0px 64px' }}
        paragraph={{ rows: 4, width: '100%' }}
      />
    );
  }, []);
};
